const sortObject  = (data, items, propName, sortAsc) => {
    const propArrA = (propName && propName.length > 0) ? propName.split(".") : [];

    return items.sort((a, b) => {
        let propA = data[a],
            propB = data[b];

        propArrA.forEach((value) => {
            propA = (typeof propA !== "undefined" && typeof propA[value] !== "undefined") ? propA[value] : "";
            propB = (typeof propB !== "undefined" && typeof propB[value] !== "undefined") ? propB[value] : "";
        });

        if (typeof propA === "string") {
            propA = propA.toLowerCase();
        }
        if (typeof propB === "string") {
            propB = propB.toLowerCase();
        }

        if (propA > propB) {
            return (sortAsc) ? 1 : -1;
        } else if (propA < propB) {
            return (sortAsc) ? -1 : 1;
        }
        return 0;
    });
};

export default sortObject;
